// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/storage/v1/audit.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Operation } from "./operation_pb.js";

/**
 * Represents a single event in the history of an entity.
 *
 * @generated from message ai.h2o.storage.AuditEvent
 */
export const AuditEvent = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.storage.AuditEvent",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "actor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "dataset_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "tag_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "comment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "deployment_environment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "restriction_role_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "timestamp", kind: "message", T: Timestamp },
    { no: 17, name: "operation", kind: "enum", T: proto3.getEnumType(Operation) },
    { no: 18, name: "registered_model_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "registered_model_version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

